export enum EnumScreenNames {
  POST_VIEW_SCREEN = "POST_VIEW_SCREEN",
  POST_GALLERY_SCREEN = "POST_GALLERY_SCREEN",
  POST_GALLERY_EXPAND_VIEW = "POST_GALLERY_EXPAND_VIEW",
  POST_GALLERY_NEXT_IMAGE = "POST_GALLERY_NEXT_IMAGE",
  POST_GALLERY_PREVIOUS_IMAGE = "POST_GALLERY_PREVIOUS_IMAGE",
  MID_SCREEN = "MID_SCREEN",
  MID_SCREEN_RATING = "MID_SCREEN_RATING",
  SHOP_LISTINGS_SCREEN = "SHOP_LISTINGS_SCREEN",
  SHOP_RATING_SCREEN = "SHOP_RATING_SCREEN",
  SHOPS_SCREEN = "SHOPS_SCREEN",
  SHOPS_LIST_SCREEN = "SHOPS_LIST_SCREEN",
  WEATHER_SCREEN = "WEATHER_SCREEN",
  WEATHER_SCREEN_WITH_CITY = "WEATHER_SCREEN_WITH_CITY",
  HOME_PAGE = "HOME_PAGE",
  LANDING_PAGE = "LANDING_PAGE",
  CUSTOM_LANDING_PAGE = "CUSTOM_LANDING_PAGE",
  SERP_SCREEN = "SERP_SCREEN",
  SIMILAR_SCREEN = "SIMILAR_SCREEN",
  RECOMMENDED_SCREEN = "RECOMMENDED_SCREEN",
  FIND_SCREEN = "FIND_SCREEN",
  DLP_SCREEN = "DLP_SCREEN",
  PRAYER_TIME_SCREEN = "PRAYER_TIME_SCREEN",
  LOAN_CALCULATOR_SCREEN = "LOAN_CALCULATOR_SCREEN",
  LOAN_CALCULATOR_DETAILS_SCREEN = "LOAN_CALCULATOR_DETAILS_SCREEN",
  SITE_MAP_SCREEN = "SITE_MAP_SCREEN",
  BANNER_ADVERTISING = "BANNER_ADVERTISING",
  BUY_VS_RENT_SCREEN = "BUY_VS_RENT_SCREEN",
  REAL_ESTATE_PRICES_SCREEN = "REAL_ESTATE_PRICES_SCREEN",
  OTHER_COUNTRIES_SCREEN = "OTHER_COUNTRIES_SCREEN",
  TERMS_OF_USE_SCREEN = "TERMS_OF_USE_SCREEN",
  PRIVACY_POLICY_SCREEN = "PRIVACY_POLICY_SCREEN",
  OPENSOOQ_LOGO_SCREEN = "OPENSOOQ_LOGO_SCREEN",
  ABOUT_US_SCREEN = "ABOUT_US_SCREEN",
  CAR_PRICES_SCREEN = "CAR_PRICES_SCREEN",
  AUTOS_SERVICE_SCREEN = "AUTOS_SERVICE_SCREEN",
  TAGS_MAIN = "TAGS_MAIN",
  TAGS_DETAILS = "TAGS_DETAILS",
  TAGS_CATEGORIES = "TAGS_CATEGORIES",
  MOBILE_TABLET_PRICES_SPECS_SCREEN = "MOBILE_TABLET_PRICES_SPECS_SCREEN",
  ADVERTISING_PRODUCTS = "ADVERTISING_PRODUCTS",
  SALES_REPRESENTATIVES = "SALES_REPRESENTATIVES",
  OPEN_SHOP = "OPEN_SHOP",
  SAFETY_TIPS_SCREEN = "SAFETY_TIPS_SCREEN",
  ADD_PICTURES_TIPS_SCREEN = "ADD_PICTURES_TIPS_SCREEN",
  SUPPORT_INDEX_SCREEN = "SUPPORT_INDEX_SCREEN",
  SUPPORT_FAQ_SCREEN = "SUPPORT_FAQ_SCREEN",
  PRAYER_TIME_SCREEN_WITH_CITY = "PRAYER_TIME_SCREEN_WITH_CITY",
  JOB_VIEW_SCREEN = "JOB_VIEW_SCREEN",
  ADVERTISING_PRODUCTS_PREMIUM = "ADVERTISING_PRODUCTS_PREMIUM",
  ADVERTISING_PRODUCTS_BUMPUP = "ADVERTISING_PRODUCTS_BUMPUP",
  ADVERTISING_PRODUCTS_TURBO = "ADVERTISING_PRODUCTS_TURBO",
  ADVERTISING_PRODUCTS_ELAS = "ADVERTISING_PRODUCTS_ELAS",
  ADVERTISING_PRODUCTS_VIP = "ADVERTISING_PRODUCTS_VIP",
  ADVERTISING_PRODUCTS_WALLET = "ADVERTISING_PRODUCTS_WALLET",
  DOWNLOAD_APP_SCREEN = "DOWNLOAD_APP_SCREEN",
  CONTACT_US_SCREEN = "CONTACT_US_SCREEN",
  ARCHIVE_POST = "ARCHIVE_POST",
  ADD_FREE_POST = "ADD_FREE_POST",
  STATIC_PAGE_ADD_POST_SCREEN = "STATIC_PAGE_ADD_POST_SCREEN",
  LANDING_BRANDS_SCREEN = "LANDING_BRANDS_SCREEN",
  CATEGORY_BRANDS_SCREEN = "CATEGORY_BRANDS_SCREEN",
  BRAND_SCREEN = "BRAND_SCREEN",
  CAR_REPORTS_SCREEN = "CAR_REPORTS_SCREEN",
  CarReportsLanding = "CarReportsLanding",
  SELLER_PAGES_SCREEN ="SELLER_PAGES_SCREEN",
  SELL_ANY_THING_SCREEN = "SELL_ANY_THING_SCREEN",
  MOTORS_SELL_IT_FOR_ME_SCREEN = "MOTORS_SELL_IT_FOR_ME_SCREEN",
  MOTORS_SELL_MY_CAR_SCREEN = "MOTORS_SELL_MY_CAR_SCREEN",
  PROPERTY_SELL_MY_PROPERTY_SCREEN = "PROPERTY_SELL_MY_PROPERTY_SCREEN",
  PROPERTY_SELL_IT_FOR_ME_SCREEN = "PROPERTY_SELL_IT_FOR_ME_SCREEN",
  PROPERTY_RENT_MY_PROPERTY_SCREEN = "PROPERTY_RENT_MY_PROPERTY_SCREEN",
  PROPERTY_RENT_IT_FOR_ME_SCREEN = "PROPERTY_RENT_IT_FOR_ME_SCREEN",
  FIND_A_JOB_SCREEN = "FIND_A_JOB_SCREEN",
  HIRE_PEOPLE_SCREEN = "HIRE_PEOPLE_SCREEN",
  TOP_SOLD_CARS_SCREEN="TOP_SOLD_CARS_SCREEN",
  SEARCH_FOR_USER_NAME="SEARCH_FOR_USER_NAME"
}
